import { logUtil } from "@repo/lib-common";

import { worldPageBidderHelper } from "../bidderConfs/worldPageBidderHelper";
import { trPageBidderHelper } from "../bidderConfs/trPageBidderHelper";
import { CountryEnum } from "@repo/lib-domain-tag/countryEnum";
import { domainCountry } from "../main";

function getPageBidder() {

    window.domainCountry = domainCountry;
    logUtil.consoleLog("getPageBidder countryInfo", domainCountry);
    if (domainCountry === CountryEnum.world) {
        return worldPageBidderHelper;
    }
    return trPageBidderHelper;
}
const pageBidderHelper = getPageBidder()
export { pageBidderHelper }


